import { GameObject, Vector2, Rectangle } from '../../../types/game.types';
import { RenderManager } from '../../../core/RenderManager';

export class Bullet implements GameObject {
  public id: string;
  public position: Vector2;
  public velocity: Vector2;
  public size: Vector2;
  public active: boolean = true;

  private renderManager: RenderManager;
  private speed: number = 400;
  private gameHeight: number;

  constructor(
    id: string,
    x: number,
    y: number,
    renderManager: RenderManager,
    gameHeight: number
  ) {
    this.id = id;
    this.position = { x: x - 2, y }; // Center the bullet
    this.velocity = { x: 0, y: -this.speed }; // Move upward
    this.size = { x: 4, y: 8 };
    this.renderManager = renderManager;
    this.gameHeight = gameHeight;
  }

  public update(deltaTime: number): void {
    // Update position
    this.position.x += this.velocity.x * deltaTime;
    this.position.y += this.velocity.y * deltaTime;
    
    // Deactivate if off screen
    if (this.position.y < -this.size.y || this.position.y > this.gameHeight) {
      this.active = false;
    }
  }

  public render(ctx: CanvasRenderingContext2D): void {
    if (!this.active) return;

    // Draw bullet as a bright white/yellow projectile
    this.renderManager.fillRect(
      this.position.x,
      this.position.y,
      this.size.x,
      this.size.y,
      '#FFFF00'
    );
    
    // Add a bright core
    this.renderManager.fillRect(
      this.position.x + 1,
      this.position.y + 1,
      this.size.x - 2,
      this.size.y - 2,
      '#FFFFFF'
    );
  }

  public getBounds(): Rectangle {
    return {
      x: this.position.x,
      y: this.position.y,
      width: this.size.x,
      height: this.size.y
    };
  }

  public destroy(): void {
    this.active = false;
  }
}